<div class="header">
  <div class="title">Rent Escalations</div>
  <button class="close-button" mat-icon-button (click)="discard()" [tabIndex]="-1">
    <mat-icon [svgIcon]="'close'"></mat-icon>
  </button>
</div>
<div class="dates-container">
  <form class="dates-container__form" [formGroup]="rentEscalationsForm">
    <ng-container formArrayName="rentEscalations">
      <table>
        <thead>
          <tr>
            <th>Start Date</th>
            <th>Start Month</th>
            <th>Amount</th>
            <th>Units</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let rentEscalationForm of rentEscalations.controls; let i = index">
            <tr [formGroupName]="i">
              <td>
                <mat-form-field>
                  <input
                    matInput
                    [matDatepicker]="startDatePicker"
                    readonly
                    formControlName="start_date"
                    placeholder="Start Date"
                  />
                  <mat-datepicker-toggle matSuffix [for]="startDatePicker"></mat-datepicker-toggle>
                  <mat-datepicker #startDatePicker></mat-datepicker>
                </mat-form-field>
              </td>
              <td>
                <mat-form-field>
                  <input matInput formControlName="start_month" placeholder="Start Month" [spellcheck]="false" />
                </mat-form-field>
              </td>
              <td>
                <mat-form-field>
                  <input matInput formControlName="amount" placeholder="$ or %" [spellcheck]="false" />
                </mat-form-field>
              </td>
              <td>
                <mat-form-field>
                  <mat-select [formControlName]="'escalation_units'" placeholder="Escalation Units">
                    <mat-option
                      *ngFor="let rentEscalationUnit of rentEscalationUnits"
                      [value]="rentEscalationUnit.name"
                    >
                      {{ rentEscalationUnit.label }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </td>
              <td>
                <button type="button" mat-icon-button matTooltip="Remove" (click)="remove(i)">
                  <mat-icon svgIcon="cancel"></mat-icon>
                </button>
              </td>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </ng-container>

    <div class="actions mt-4 border-t pt-4">
      <div class="formatting">
        <button class="add-contact" mat-flat-button [color]="'secondary'" (click)="add()">
          <mat-icon [svgIcon]="'add'"></mat-icon>
          Add Row
        </button>
      </div>
      <div class="buttons">
        <button class="discard-button" mat-button type="button" (click)="discard()">
          <span>Close</span>
        </button>
        <button class="send-button" mat-flat-button type="submit" [color]="'primary'" (click)="save()">
          <span>Save</span>
        </button>
      </div>
    </div>
  </form>
</div>
